import { REACT_SELECTO_RECTANGLE_Z_INDEX } from 'consts/zIndex'
import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
    border: 0;
    outline: none;
  }

  html, body, #root {
      width: 100%;
      height: 100%;    
  }

  .selecto-container {
    z-index: ${REACT_SELECTO_RECTANGLE_Z_INDEX} !important;
  }
`

export default GlobalStyles
